import createAPI from '../axios'
//import { config } from 'vue/types/umd';

//工作量相关API

const teachingPlanAdultEducation = {
	courseConfirm: {
		queryList: config => createAPI('/courseConfirmAdultEducation/queryList', 'post', config),
        deptOption: config => createAPI('/courseConfirmAdultEducation/deptOption', 'post', config),
        majorOption: config => createAPI('/courseConfirmAdultEducation/majorOption', 'post', config),
        gradeOption: config => createAPI('/courseConfirmAdultEducation/gradeOption', 'post', config),
        auditOption: config => createAPI('/courseConfirmAdultEducation/auditOption', 'post', config),
        queryTeachingProgress: config => createAPI('/courseConfirmAdultEducation/queryTeachingProgress', 'post', config),
        saveCourseConfirm: config => createAPI('/courseConfirmAdultEducation/saveCourseConfirm', 'post', config),
        submitCourseConfirm: config => createAPI('/courseConfirmAdultEducation/submitCourseConfirm', 'post', config),
        updateAuditState: config => createAPI('/courseConfirmAdultEducation/updateAuditState', 'post', config),
        queryAuditFlow: config => createAPI('/courseConfirmAdultEducation/queryAuditFlow', 'post', config),
        queryChangeTeachingProgress: config => createAPI('/courseConfirmAdultEducation/queryChangeTeachingProgress', 'post', config),
        audit: config => createAPI('/courseConfirmAdultEducation/audit', 'post', config),
        updateAuditState_jxjcbg: config => createAPI('/courseConfirmAdultEducation/updateAuditState_jxjcbg', 'post', config),
        saveModCourseConfirm: config => createAPI('/courseConfirmAdultEducation/saveModCourseConfirm', 'post', config),
        checkCurTime: config => createAPI('/courseConfirmAdultEducation/checkCurTime', 'post', config),
	},
    teachingCoursePlan: {
        list: config => createAPI('/teachingCoursePlanAdultEducation/list', 'post', config),
        queryTree: config => createAPI('/teachingCoursePlanAdultEducation/queryTree', 'post', config),
        baseParam: config => createAPI('/teachingCoursePlanAdultEducation/baseParam', 'post', config),
        classFixed: config => createAPI('/teachingCoursePlanAdultEducation/classFixed', 'post', config),
        initOption: config => createAPI('/teachingCoursePlanAdultEducation/initOption', 'post', config),
		courseOption: config => createAPI('/teachingCoursePlanAdultEducation/courseOption', 'post', config),
        saveRec: config => createAPI('/teachingCoursePlanAdultEducation/saveRec', 'post', config),
        checkDelSKJH: config => createAPI('/teachingCoursePlanAdultEducation/checkDelSKJH', 'post', config),
        delRec: config => createAPI('/teachingCoursePlanAdultEducation/delRec', 'post', config),
        submit: config => createAPI('/teachingCoursePlanAdultEducation/submit', 'post', config),
        updateAuditState: config => createAPI('/teachingCoursePlanAdultEducation/updateAuditState', 'post', config),
        gradeOption: config => createAPI('/teachingCoursePlanAdultEducation/gradeOption', 'post', config),
        deptOption: config => createAPI('/teachingCoursePlanAdultEducation/deptOption', 'post', config),
        majorOption: config => createAPI('/teachingCoursePlanAdultEducation/majorOption', 'post', config),
        classOption: config => createAPI('/teachingCoursePlanAdultEducation/classOption', 'post', config),
        siteOption: config => createAPI('/teachingCoursePlanAdultEducation/siteOption', 'post', config),
        majorSearchOption: config => createAPI('/teachingCoursePlanAdultEducation/majorSearchOption', 'post', config),
        classSearchOption: config => createAPI('/teachingCoursePlanAdultEducation/classSearchOption', 'post', config),
        exportSkjh : config => createAPI('/teachingCoursePlanAdultEducation/exportSkjh', 'post', config),
        importSkjh: config => createAPI('/teachingCoursePlanAdultEducation/importSkjh', 'post', config),
        checkEditInfo: config => createAPI('/teachingCoursePlanAdultEducation/checkEditInfo', 'post', config),
        courseOption_multi: config => createAPI('/teachingCoursePlanAdultEducation/courseOption_multi', 'post', config),
        saveTeachingPlanSet: config => createAPI('/teachingCoursePlanAdultEducation/saveTeachingPlanSet', 'post', config),
    },
};


export default teachingPlanAdultEducation;



// WEBPACK FOOTER //
// ./src/api/modules/teachingPlanAdultEducation.js